import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from './apis';
import Swal from 'sweetalert2';
import { RootState } from '../../domain/models/RootState';

export const getWareHouseById = createAsyncThunk<
  any,
  number,
  { state: RootState }
>('Warehouses/getWarehouseById', async (id: number, thunkAPI) => {
  try {
    const { auth }: RootState = thunkAPI.getState();
    const res: any = await API.getAllWarehouses(auth.token, {
      filter: `&id=${id}`,
    });
    return res.data.warehouses[0];
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Hubo un error al cargar los datos',
      text: 'intenta de nuevo',
    });
    throw error;
  }
});

export const getAllWarehouses = createAsyncThunk<
  any,
  any,
  {
    state: RootState;
  }
>(
  'Warehouses/getAllWarehouses',
  async ({ filter, pagination }: any, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const res: any = await API.getAllWarehouses(auth.token, {
        filter,
        pagination,
      });
      return res.data;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);

export const updateWarehouse = createAsyncThunk<
  any,
  any,
  {
    state: RootState;
  }
>('Warehouses/updateWarehouse', async ({ values, text }: any, thunkAPI) => {
  try {
    const { auth }: RootState = thunkAPI.getState();
    const res = await API.updateWarehouse(auth.token, values);
    Swal.fire({
      icon: 'success',
      title: `${text || 'Editado'} con exito`,
    });
    return res;
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: `Hubo un error al editar los datos`,
      text: 'intenta de nuevo',
    });
    throw error;
  }
});

export const createWarehouse = createAsyncThunk<
  any,
  any,
  {
    state: RootState;
  }
>('Warehouses/createWarehouse', async (warehouse: any, thunkAPI) => {
  try {
    const { auth }: RootState = thunkAPI.getState();
    const res = await API.createWarehouse(auth.token, warehouse);
    if (res.status === 200) {
      Swal.fire('Correcto', 'El almacen se agregó correctamente', 'success');
      return true;
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Hubo un error al crear el almacen',
      text: 'Por favor, intenta de nuevo',
    });
    throw error;
  }
});
